import { UploadOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { useCreateQuestionsMutation, useCreateUsersMutation } from "api";
import { OBJ_COLOR } from "commons/constants";
import styled from "styled-components";
import { resultQuestions, resultUsers } from "utils";
import * as XLSX from "xlsx";

const BtnLabel = styled.label`
	background: ${OBJ_COLOR.SUCCESS};
	border-radius: 5px;
	padding: 9px 24px;
	color: #fff;
	cursor: pointer;
	input {
		display: none;
	}
`;

interface TemplateProps {
	nameSheet: string;
	header: string[];
}
export const Template = ({ nameSheet, header }: TemplateProps) => {
	const [createQuestions] = useCreateQuestionsMutation();
	const [createUsers] = useCreateUsersMutation();

	const importExcel = (file: any, nameSheet: string, header: string[]) => {
		const fileReader = new FileReader();

		fileReader.onload = async (event: any) => {
			try {
				const { result } = event.target;
				const workbook = XLSX.read(result, { type: "binary" });

				if (nameSheet === "Bộ câu hỏi tiếng Việt") {
					const DATA: { languageId: number; data: any[] }[] = [];
					let count = 0;
					for (const key in workbook.Sheets) {
						if (Object.prototype.hasOwnProperty.call(workbook.Sheets, key)) {
							const data = XLSX.utils.sheet_to_json(workbook.Sheets[key], { header });
							data.shift();
							if (key.toLowerCase().indexOf("câu hỏi") !== -1) {
								const languageId = ++count;
								DATA.push({
									languageId,
									data: resultQuestions(data),
								});
							}
						}
					}
					await createQuestions(DATA).unwrap();
				} else {
					const data = XLSX.utils.sheet_to_json(workbook.Sheets[nameSheet], { header });
					data.shift();
					const users = resultUsers(data);
					await createUsers(users).unwrap();
				}

				notification.success({
					message: "Success",
				});
			} catch (e) {
				notification.error({
					message: "file type is incorrect!",
				});
			}
		};
		fileReader.readAsBinaryString(file);
	};

	const onChange = (event: any) => {
		const { files } = event.target;
		// const { files } = event.currentTarget.files;
		// console.log(event.currentTarget.files);
		if (files.length === 1) {
			// Process a file if we have exactly one
			importExcel(files[0], nameSheet, header);
		}
	};

	return (
		<>
			<BtnLabel>
				<UploadOutlined style={{ marginRight: 10 }} />
				Upload <br />
				<input
					id="inputTag"
					type="file"
					accept=".xlsx, .xls"
					onChange={(e) => onChange(e)}
					// onClick={(e) => {
					// 	e.target.value = null;
					// }}
				/>
			</BtnLabel>
		</>
	);
};
